import { useCallback, useState } from 'react';

import {
  isAiHourlyQuotaReached,
  requiresSuartePlusForAskAi,
  resolveAiAccessErrorMessage,
  resolveWeeklyAiQuotaMessage,
} from '@/utils/aiAccessErrors';

export default function useAskAiEntitlement() {
  const [quotaMessage, setQuotaMessage] = useState(null);
  const [showSuartePlusPopup, setShowSuartePlusPopup] = useState(false);

  const handleAccessError = useCallback((data, t) => {
    if (requiresSuartePlusForAskAi(data)) {
      setQuotaMessage(resolveWeeklyAiQuotaMessage(data, t));
      setShowSuartePlusPopup(true);
      return true;
    }

    if (isAiHourlyQuotaReached(data)) {
      setQuotaMessage(resolveAiAccessErrorMessage(data, t));
      return true;
    }

    return false;
  }, []);

  const clearQuotaMessage = useCallback(() => setQuotaMessage(null), []);

  return {
    clearQuotaMessage,
    handleAccessError,
    quotaMessage,
    setShowSuartePlusPopup,
    showSuartePlusPopup,
  };
}
